import { appeler } from './api.js';

export interface DemandeCreationProjet {
  readonly nom: string;
  readonly code: string;
  readonly description?: string | undefined;
}

export interface VueProjet {
  readonly code: string;
  readonly nom: string;
}

export async function creerProjet(
  espace: string, d: DemandeCreationProjet,
): Promise<{ readonly projet: VueProjet }> {
  return appeler<{ projet: VueProjet }>(
    'POST', `/locataires/${encodeURIComponent(espace)}/projets`, d);
}

/**
 * LA FICHE D UN PROJET [29-F, dette 60]. Distincte de VueProjet, qui est le
 * retour de CREATION : deux champs y suffisent. Ici la description compte,
 * l ecran Parametres l edite.
 */
export interface FicheProjet {
  readonly code: string;
  readonly nom: string;
  readonly description: string | null;
}

/** Le nom LISIBLE d un projet, que la coquille n avait aucun moyen d obtenir
 *  avant cette route -- elle affichait son code [dette 60]. */
export async function lireProjet(
  espace: string, projet: string,
): Promise<{ readonly projet: FicheProjet }> {
  return appeler<{ projet: FicheProjet }>(
    'GET', `/locataires/${encodeURIComponent(espace)}`
      + `/projets/${encodeURIComponent(projet)}`);
}

/**
 * MODIFIER LES METADONNEES. Le code n est PAS transmis : il vit dans l URL
 * et le serveur ne l accepte pas dans le corps. Les DEUX cles partent a
 * chaque fois -- le contrat serveur les exige, il n y a pas de patch partiel.
 */
export async function modifierProjet(
  espace: string, projet: string, nom: string, description: string | null,
): Promise<{ readonly projet: VueProjet }> {
  return appeler<{ projet: VueProjet }>(
    'PATCH', `/locataires/${encodeURIComponent(espace)}`
      + `/projets/${encodeURIComponent(projet)}`, { nom, description });
}

/**
 * DU NOM VERS LE CODE. Confort de saisie, JAMAIS une garantie : le serveur
 * revalide le format et l unicite, et c est lui qui tranche [29-C].
 *
 * La normalisation Unicode NFD separe la lettre de son accent ; on retire
 * ensuite les marques combinantes. « Réservation d'été » donne
 * `reservation-d-ete`, ce qui est laid mais VISIBLE et corrigeable avant
 * creation -- l utilisateur voit le champ.
 *
 * Le resultat peut etre VIDE (un nom tout en ideogrammes) ou commencer par un
 * tiret. On ne corrige pas ici : le champ montre ce qui sortira, et le refus
 * appartient au serveur. Deriver un code faux SILENCIEUSEMENT serait pire.
 */
export function deriverCode(nom: string): string {
  return nom
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 63)
    .replace(/-+$/g, '');
}
